import * as React from "react";
import Select from "react-select";
import { Classification } from "../../FeralScan.dtos";

export interface IClassificationSelectOption {
    label: string;
    value: Classification[];
}

export interface IClassificationSelect {
    label: string;
    className: string;
    options: IClassificationSelectOption[];
    onChange: any;
    value: any;
}

class ClassificationSelect extends React.PureComponent<IClassificationSelect, any> {

    componentDidMount() {
        this.props.onChange(this.props.options[0])
    }

    render() {
        return (
            <div className="filter-select">
                {
                    this.props.label !== undefined ? <label className="my-0">{this.props.label}</label>
                        : undefined
                }
                <Select
                    //className={this.props.className}
                    options={this.props.options}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    isSearchable={false}
                    isClearable={false}
                    placeholder={undefined}
                />
            </div>
        );
    }
}

export default ClassificationSelect;
